import AppConstants from '../../../../config/app.constants'
class ImportFileViewController {
    /*@ngInject*/
    constructor(Auth, $state, User, DateUtil, $translate, $q, Modal, SetupService, ImportFileViewService, $rootScope) {
        this.DateUtil = DateUtil;
        this.Modal = Modal;
        this.SetupService = SetupService
        this.User = User;
        this.Auth = Auth;
        this.$translate = $translate;
        this.$q = $q;
        this.$state = $state;
        this.ImportFileViewService = ImportFileViewService;
        this.$rootScope = $rootScope;

        this.model = {
            currentBranch: User.getUser().branchId,
            branchCurrentVaultDate: '',
            loading: false,
            importFileViewObj: {
                results: [],
                totalRoutes: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                loading: false,
                status: null,
                statusList: [
                    { label: 'Success', value: 'OK' },
                    { label: 'Failed', value: 'ERROR' }
                ],
                fileAdapterList: [],
                fileAdapter: null
            },
            evertecBatchFileObj: {
                results: [],
                totalRoutes: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                loading: false,
                statusList: [
                    { label: 'Success', value: 'OK' },
                    { label: 'Failed', value: 'ERROR' }
                ],
                status: null,
                searchText: null
            },
            stats: {
                importFile: 'importFile',
                evertecBatch: 'evertecBatch'
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null,
            },
            currentStat: 'importFile'
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/import-file-view');
    }

    $onInit() {
        this.model.loading = true;
        this.$q.all([
            this.SetupService.get(this.model.currentBranch),
            this.ImportFileViewService.getFileAdapterTypes()
        ])
            .then((data) => {
                this.model.setupDetails = data[0];
                this.model.importFileViewObj.fileAdapterList = data[1].results;
                this.model.formattedvaultDate = this.DateUtil.convertToDate(this.model.setupDetails.currentVaultDate);
                this.loadDateRangePicker(this.model.dateRangeOptions, 'dateRange');
                this.model.dateRangeOptions.startDate = moment().subtract(10, 'days').format('YYYY-MM-DD HH:mm:ss');
                this.model.dateRangeOptions.endDate = moment();
                this.loadData();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    loadDateRangePicker(dateRangeOption, modelVal) {
        this.model[modelVal] = {
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.filterImportFileView();
                }
            },
            ranges: {
                'Running 10 Days': [
                    moment().subtract(10, 'days').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ]
            }
        }
    }

    loadData() {
        if (this.model.currentStat === this.model.stats.importFile) this.importFileView();
        if (this.model.currentStat === this.model.stats.evertecBatch) this.evertecBatchFileView();
    }

    pageChange() {
        this.loadData();
    }

    tabSelection() {
        if (this.model.currentStat === this.model.stats.importFile) {
            this.model.evertecBatchFileObj.pagination.page = 1;
            this.model.evertecBatchFileObj.status = null;
            this.model.evertecBatchFileObj.searchText = null;
            this.importFileView();
        }
        else if (this.model.currentStat === this.model.stats.evertecBatch) {
            this.model.importFileViewObj.pagination.page = 1;
            this.model.importFileViewObj.status = null;
            this.model.importFileViewObj.fileAdapter = null;
            this.evertecBatchFileView();
        }
    }

    filterEvertecBatchView() {
        this.model.evertecBatchFileObj.pagination.page = 1;
        this.evertecBatchFileView();
    }

    filterImportFileView() {
        this.model.importFileViewObj.pagination.page = 1;
        this.importFileView();
    }

    getStartDate() {
        return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD 00:00:00') : null;
    }

    getEndDate() {
        return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59') : null;
    }

    importFileView() {
        const status = this.model.importFileViewObj.status;
        const fileAdapter = this.model.importFileViewObj.fileAdapter;
        const startDate = this.getStartDate();
        const endDate = this.getEndDate();

        this.model.importFileViewObj.loading = true;
        this.ImportFileViewService.importFiles(startDate, endDate, status, fileAdapter, this.model.importFileViewObj.pagination.pageLimit,
            (this.model.importFileViewObj.pagination.page - 1) * this.model.importFileViewObj.pagination.pageLimit)
            .then((data) => {
                this.model.importFileViewObj.pagination.total = data.total;
                this.model.importFileViewObj.results = data.results;
                this.model.importFileViewObj.totalRecords = data.total;
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.importFileViewObj.loading = false;
            })
    }

    evertecBatchFileView() {
        const searchText = this.model.evertecBatchFileObj.searchText;
        const status = this.model.evertecBatchFileObj.status;

        this.model.evertecBatchFileObj.loading = true;
        this.ImportFileViewService.evertecBatchFiles(searchText, status, this.model.evertecBatchFileObj.pagination.pageLimit,
            (this.model.evertecBatchFileObj.pagination.page - 1) * this.model.evertecBatchFileObj.pagination.pageLimit)
            .then((data) => {
                this.model.evertecBatchFileObj.pagination.total = data.total;
                this.model.evertecBatchFileObj.results = data.results;
                this.model.evertecBatchFileObj.totalRecords = data.total;
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.evertecBatchFileObj.loading = false;
            })
    }

    formatFileSize(bytes, decimalPoint) {
        if (bytes == 0) return '0 Bytes';
        const k = 1000,
            dm = decimalPoint || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    formatSeconds(duration) {
        if (!duration) return;
        return Math.round(duration * 100) / 100 + ' Seconds';
    }

    formatDate(date) {
        if (!date) return;
        return moment(date, 'MMDDYY').format('YYYY-MM-DD');
    }
}

export default ImportFileViewController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/import_file_view/import_file_view.controller.js